'use client';

import React, { FC, useEffect, useState } from 'react';
import { Button } from '../../../../core-components/Button';
import { Dialog, DialogContent, DialogTrigger } from '../../../shared/Dialog';
import { QuickAccessTilesGroup } from '../../../shared/QuickAccessTile';
type Props = {
  title: string;
  ctaLabel: string;
  cards: React.ReactNode;
  openEvent: string;
};

/**
 * QuickAccessDialog displays quick access items in a dialog.
 *
 * Z-Index Stacking:
 * - Sets z-[1100] explicitly via overlayClassName
 * - MXP365 dialogs use DialogPersistent with z-[1200]
 * - This ensures MXP365 dialogs appear on top when opened from quick access items
 * - Dialog automatically closes when MXP365 dialog opens (via MXP365_EVENTS.OPEN listener)
 */
export const QuickAccessDialog: FC<Props> = ({
  title,
  ctaLabel,
  cards,
  openEvent
}) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const handleMxp365Open = () => {
      setOpen(false);
    };
    window.addEventListener(openEvent, handleMxp365Open);
    return () => window.removeEventListener(openEvent, handleMxp365Open);
  }, []);
  return <Dialog open={open} onOpenChange={setOpen} data-sentry-element="Dialog" data-sentry-component="QuickAccessDialog" data-sentry-source-file="QuickAccessDialog.tsx">
      <DialogTrigger asChild data-sentry-element="DialogTrigger" data-sentry-source-file="QuickAccessDialog.tsx">
        <Button className="md:hidden" variant="secondary" data-sentry-element="Button" data-sentry-source-file="QuickAccessDialog.tsx">
          {ctaLabel}
        </Button>
      </DialogTrigger>
      <DialogContent title={title} disableSpacing bodyClassName={'bg-gray'} overlayClassName="z-[1100]" data-sentry-element="DialogContent" data-sentry-source-file="QuickAccessDialog.tsx">
        <QuickAccessTilesGroup className="p-6" data-sentry-element="QuickAccessTilesGroup" data-sentry-source-file="QuickAccessDialog.tsx">{cards}</QuickAccessTilesGroup>
      </DialogContent>
    </Dialog>;
};